import React from "react";
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next';

const ReadOnlyInputFields = ({ inputValue, labelValue}) =>
{
  const { t } = useTranslation();
  return (
    <div className="col-md-24 form-group">
      <div className="placeholderContainer border-bottom">
      <label htmlFor={labelValue} className="form-label">{t(`widget.${labelValue}`)}</label>
        <input
          id={labelValue}
          type="text"
          autoComplete="off"
          className="form-control text-box cursor-disabled read-only-field"
          value={inputValue}
          readOnly
        />
      </div>
    </div>
  );
};

ReadOnlyInputFields.propTypes = {
  inputValue: PropTypes.string,
  labelValue: PropTypes.string
};

export default ReadOnlyInputFields;
